import { Web727 } from "web727token";

const axios = {
  get: (...args) => Web727.client.get(...args),
  post: (...args) => Web727.client.post(...args),
  put: (...args) => Web727.client.put(...args),
  patch: (...args) => Web727.client.patch(...args),
  delete: (...args) => Web727.client.delete(...args),
};

export default axios;